import { Suspense, lazy, useState } from "react";

/**
 * Code-splits a modal: its chunk is only downloaded the first time it opens.
 * After that it stays mounted, so its close animation and state keep working.
 *
 *   const AuthModal = lazyModal(() => import("./auth/AuthModal"), () => useAuth().isAuthModalOpen);
 *
 * `useIsOpen(props)` is called as a hook on every render and returns whether the modal is open.
 */
export function lazyModal(factory, useIsOpen) {
  const Modal = lazy(factory);

  return function LazyModal(props) {
    const isOpen = useIsOpen(props);
    const [hasOpened, setHasOpened] = useState(false);
    if (isOpen && !hasOpened) setHasOpened(true);

    return hasOpened ? (
      <Suspense fallback={null}>
        <Modal {...props} />
      </Suspense>
    ) : null;
  };
}
